export const RETURN_TO_PARAM = "returnTo";

export function getSafeReturnTo(value?: string | string[] | null): string | undefined {
  const returnTo = Array.isArray(value) ? value[0] : value;

  if (!returnTo || !returnTo.startsWith("/") || returnTo.startsWith("//")) {
    return undefined;
  }

  return returnTo;
}

export function appendReturnTo(href: string, returnTo?: string): string {
  const safeReturnTo = getSafeReturnTo(returnTo);

  if (!safeReturnTo || !href.startsWith("/") || href.startsWith("//")) {
    return href;
  }

  const url = new URL(href, "https://itshealer.local");
  url.searchParams.set(RETURN_TO_PARAM, safeReturnTo);

  return `${url.pathname}${url.search}${url.hash}`;
}
